export default __webpack_public_path__ + "static/tile-variant-dont-b6cdcda35a743d2a86f7f44b7e925e1f.png";